var React = require('react');

function MainCircle (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"39","cy":"101","r":"16","fill":"#FEAC00","fillOpacity":"0.35","key":0}),React.createElement("circle",{"cx":"23","cy":"23","r":"23","fill":"#FEAC00","fillOpacity":"0.55","key":1}),React.createElement("circle",{"cx":"148.5","cy":"100.5","r":"46.5","fill":"#FEAC00","fillOpacity":"0.2","key":2})]);
}

MainCircle.defaultProps = {"width":"195","height":"147","viewBox":"0 0 195 147","fill":"none"};

module.exports = MainCircle;

MainCircle.default = MainCircle;
